import React from 'react';

const Video = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path d="M 31.36,4.48 L 31.36,27.52 L 0.64,27.52 L 0.64,4.48 Z M 1.92,26.24 L 30.080,26.24 L 30.080,5.76 L 1.92,5.76 Z M 1.92,26.24M 8.32,16.064 C 8.32,11.822 11.758,8.384 16,8.384 C 20.242,8.384 23.68,11.822 23.68,16.064 C 23.68,20.306 20.242,23.744 16,23.744 C 11.758,23.744 8.32,20.306 8.32,16.064 Z M 22.4,16.064 C 22.4,12.529 19.535,9.664 16,9.664 C 12.465,9.664 9.6,12.529 9.6,16.064 C 9.6,19.599 12.465,22.464 16,22.464 C 19.535,22.464 22.4,19.599 22.4,16.064 Z M 22.4,16.064M 13.44,12.224 L 19.84,16.032 L 13.44,19.84 Z M 17.337,16.032 L 14.72,14.475 L 14.72,17.589 Z M 17.337,16.032" />
  </svg>
);

export default Video;
